/**
 * Progress bar component
 */

import { Progress } from '@ox/blox';

interface ProgressBarProps {
  currentSection: number;
  totalSections: number;
}

export function ProgressBar({ currentSection, totalSections }: ProgressBarProps) {
  return (
    <div className="progress-bar-container">
      <Progress
        value={currentSection}
        max={totalSections}
        label={`Section ${currentSection} of ${totalSections}`}
      />
    </div>
  );
}
